import React from 'react';
import { DefaultTheme } from 'styled-components';

interface Props {
  theme?: DefaultTheme;
}

const IllustrationHealth: React.FC<React.PropsWithChildren<Props>> = ({
  theme,
  ...otherProps
}) => {
  return (
    <svg
      width={304}
      height={304}
      fill="none"
      viewBox="0 0 304 304"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <g clipPath="url(#clip0_1627_10496)">
        <path stroke="#C0C2C9" d="M0 304.03L304 304.03"></path>
        <path
          fill="#F0F1F3"
          d="M280.092 64.714l-1.684-2.77c-14.173-23.332-39.798-37.398-66.823-35.69a71.66 71.66 0 00-10.364 1.417c-24.562 5.254-45.938 23.811-54.8 47.577-5.182 13.976-6.665 30.074-16.556 41.165-12.871 14.442-34.72 14.882-53.926 14.293-19.205-.589-41.074-.084-53.88 14.409-8.019 9.059-10.571 22-9.923 34.145 1.73 32.203 24.16 60.983 52.74 75.289 28.579 14.306 62.184 15.588 93.432 9.298 43.814-8.819 85.419-33.031 110.448-70.424 25.029-37.392 31.358-88.34 11.336-128.709z"
        ></path>
        <ellipse
          cx="66.777"
          cy="89.166"
          fill="#F0F1F3"
          rx="25.636"
          ry="25.636"
        ></ellipse>
        <ellipse
          cx="253.159"
          cy="257.534"
          fill="#F0F1F3"
          rx="20.786"
          ry="20.786"
        ></ellipse>
        <g filter="url(#filter0_dd_1627_10496)">
          <rect
            width="201.663"
            height="162.535"
            x="51.168"
            y="104.372"
            fill="#fff"
            rx="4"
          ></rect>
        </g>
        <path
          stroke="#888D9B"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M261.861 48.688v123.684a8 8 0 01-8 8h-43.92M62.455 65.243v110.139a8 8 0 008 8h25.862"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M111.29 189.367h9.285l10.116-18.872 10.266 22.647 1.755-4.662h12.852l13.683-31.082 8.813 28.95h16.098a27.347 27.347 0 00-1.396-37.16 27.387 27.387 0 00-38.726 0l-2.831 2.831-2.831-2.85a27.384 27.384 0 00-38.726 38.708l1.642 1.49z"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M174.513 190.971l-6.077-20.004-9.738 22.137h-12.682l-4.624 12.361-11.04-24.251-6.907 12.947h-7.361l35.122 35.121 38.33-38.311h-15.023z"
        ></path>
        <g filter="url(#filter1_dd_1627_10496)">
          <rect
            width="105.347"
            height="105.347"
            x="10.535"
            y="17.085"
            fill="#fff"
            rx="4"
          ></rect>
        </g>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M47.993 90.37l11.37 3.367-1.937 6.538a3.129 3.129 0 01-3.887 2.11l-5.391-1.597a3.124 3.124 0 01-2.111-3.887l1.936-6.537.02.006z"
        ></path>
        <path
          fill="#222"
          d="M47.994 90.37l11.37 3.367-1.94 6.544a3.113 3.113 0 01-3.87 2.101l-5.39-1.597a3.116 3.116 0 01-2.213-2.66 3.113 3.113 0 01.111-1.21l1.939-6.543-.007-.002z"
          opacity="0.3"
        ></path>
        <path
          fill="#222"
          d="M57.586 100.273a47.166 47.166 0 01-5.764-1.51 48.504 48.504 0 01-5.623-1.87c1.95.387 3.875.894 5.764 1.518 1.91.508 3.787 1.13 5.623 1.862z"
        ></path>
        <path
          fill="#222"
          d="M49.77 97.891a1.406 1.406 0 011.736-.991l2.277.703a1.406 1.406 0 01.914 1.771l-4.927-1.483z"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M58.858 35.145L46.206 87.446a4.449 4.449 0 002.959 5.37l8.287 2.46a4.442 4.442 0 005.342-2.727l19.87-50.362-23.806-7.042z"
        ></path>
        <path
          fill="#222"
          d="M81.027 46.334c0 .099-5.244-1.363-11.647-3.26-6.403-1.899-11.576-3.515-11.548-3.614.028-.098 5.243 1.364 11.654 3.262 6.41 1.897 11.569 3.514 11.54 3.612z"
        ></path>
        <path
          fill="#222"
          d="M59.66 40.058a7.029 7.029 0 01.463-2.2c.159-.74.432-1.452.809-2.109a6.895 6.895 0 01-.457 2.2 6.98 6.98 0 01-.816 2.109zM61.55 40.613a13.518 13.518 0 011.272-4.295 7.03 7.03 0 01-.464 2.2 7.212 7.212 0 01-.808 2.095zM63.434 41.175a7.026 7.026 0 01.464-2.2 7.082 7.082 0 01.808-2.108 6.894 6.894 0 01-.457 2.2 6.982 6.982 0 01-.815 2.108zM65.324 41.73a13.517 13.517 0 011.273-4.294c-.191 1.49-.621 2.94-1.273 4.295zM67.209 42.293a7.026 7.026 0 01.463-2.2 7.08 7.08 0 01.809-2.109 6.894 6.894 0 01-.457 2.2 6.982 6.982 0 01-.815 2.109zM69.099 42.848a13.516 13.516 0 011.272-4.294c-.191 1.49-.62 2.94-1.272 4.294zM70.982 43.41a7.03 7.03 0 01.464-2.2 7.086 7.086 0 01.809-2.108 6.894 6.894 0 01-.457 2.2 6.98 6.98 0 01-.816 2.108zM72.867 43.966c.04-.753.196-1.495.463-2.2.154-.743.43-1.456.816-2.109a7.282 7.282 0 01-.464 2.2 6.888 6.888 0 01-.815 2.109zM74.757 44.528c.03-.753.185-1.497.457-2.2.159-.742.434-1.453.815-2.109a7.026 7.026 0 01-.464 2.2 7.082 7.082 0 01-.808 2.109zM76.641 45.083c.191-1.49.62-2.94 1.272-4.294a13.519 13.519 0 01-1.272 4.294zM78.532 45.646c.03-.754.184-1.497.456-2.2.156-.743.431-1.455.816-2.11a7.029 7.029 0 01-.464 2.2 7.088 7.088 0 01-.808 2.11zM80.416 46.2c.19-1.49.62-2.94 1.272-4.294a13.52 13.52 0 01-1.272 4.295z"
        ></path>
        <path
          fill="#fff"
          d="M61.915 62.486l.893-2.994 2.96.879-.83 2.804 2.418.71-.872 2.945-2.678-.787-.759 2.566-2.474-.738.815-2.756-2.917-.864.773-2.608 2.671.843z"
        ></path>
        <path
          fill="#fff"
          d="M69.07 65.868c-.041 0 .155-.563.205-1.596a6.685 6.685 0 00-1.195-4.09 6.193 6.193 0 00-2.207-1.955 6.115 6.115 0 00-3.297-.653 6.326 6.326 0 00-3.43 1.406 6.726 6.726 0 00-2.158 7.281 6.276 6.276 0 002.109 3.037 6.157 6.157 0 003.12 1.244 6.235 6.235 0 002.918-.429 6.649 6.649 0 003.226-2.811c.527-.893.66-1.462.703-1.448-.014.14-.048.276-.099.407-.12.386-.28.759-.478 1.11a6.698 6.698 0 01-3.254 2.96 6.326 6.326 0 01-6.326-.787 6.586 6.586 0 01-2.25-3.191 7.028 7.028 0 012.25-7.662 6.551 6.551 0 013.627-1.455 6.368 6.368 0 013.465.703c.917.498 1.7 1.21 2.285 2.074A6.677 6.677 0 0169.4 64.23a6.111 6.111 0 01-.204 1.195 1.468 1.468 0 01-.126.443z"
        ></path>
        <g filter="url(#filter2_dd_1627_10496)">
          <rect
            width="79.762"
            height="79.762"
            x="221.228"
            y="8.055"
            fill="#fff"
            rx="4"
          ></rect>
        </g>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M254.687 53.438l1.015 1.016 11.925-11.924-1.016-1.016-11.924 11.924zm4.56 3.047l1.016 1.016 10.39-10.39-1.015-1.016-10.391 10.39zm5.922 1.686l1.015 1.016 6.155-6.155-1.015-1.016-6.155 6.155zm19.663 3.119l-10.39 10.39 1.016 1.016 10.39-10.39-1.016-1.016zm-12.066 4.469l1.016 1.015 6.155-6.155-1.016-1.016-6.155 6.156zM251.65 48.888l1.015 1.016 10.381-10.39-1.016-1.017-10.38 10.391zm-1.676-5.911l1.016 1.015 6.155-6.155-1.016-1.015-6.155 6.155zm-13.519-9.284l1.016 1.016 10.39-10.39-1.015-1.016-10.391 10.39zm5.922 1.686l1.015 1.016 6.165-6.145-1.015-1.016-6.165 6.145z"
        ></path>
        <path
          fill="#fff"
          d="M254.687 53.438l1.015 1.016 11.925-11.924-1.016-1.016-11.924 11.924zm4.56 3.047l1.016 1.016 10.39-10.39-1.015-1.016-10.391 10.39zm5.922 1.686l1.015 1.016 6.155-6.155-1.015-1.016-6.155 6.155zm19.663 3.119l-10.39 10.39 1.016 1.016 10.39-10.39-1.016-1.016zm-12.066 4.469l1.016 1.015 6.155-6.155-1.016-1.016-6.155 6.156zM251.65 48.888l1.015 1.016 10.381-10.39-1.016-1.017-10.38 10.391zm-1.676-5.911l1.016 1.015 6.155-6.155-1.016-1.015-6.155 6.155zm-13.519-9.284l1.016 1.016 10.39-10.39-1.015-1.016-10.391 10.39zm5.922 1.686l1.015 1.016 6.165-6.145-1.015-1.016-6.165 6.145z"
          opacity="0.45"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M277.458 77.388c-4.438-4.428-5.251-11.284-5.708-17.917-.437-6.327-1.198-12.828-5.22-16.85-4.023-4.022-10.533-4.794-16.851-5.22-6.642-.458-13.488-1.28-17.917-5.709l1.179-1.178c4.062 4.063 10.532 4.784 16.85 5.22 6.632.458 13.488 1.27 17.917 5.699 4.428 4.428 5.251 11.284 5.708 17.927.437 6.317 1.198 12.828 5.221 16.85l-1.179 1.178z"
        ></path>
        <path
          fill={theme ? theme.primary[500] : '#C0C2C9'}
          d="M254.606 54.535c-4.428-4.428-5.251-11.274-5.698-17.917-.437-6.317-1.198-12.828-5.221-16.85l1.179-1.178c4.428 4.428 5.241 11.284 5.698 17.917.436 6.317 1.198 12.828 5.22 16.85 4.022 4.022 10.533 4.784 16.861 5.22 6.632.458 13.488 1.28 17.916 5.709l-1.178 1.178c-4.062-4.063-10.532-4.784-16.86-5.22-6.633-.458-13.478-1.27-17.917-5.709z"
        ></path>
      </g>
      <defs>
        <filter
          id="filter0_dd_1627_10496"
          width="205.663"
          height="166.535"
          x="49.168"
          y="102.872"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.5"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10496"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1627_10496"
            result="effect2_dropShadow_1627_10496"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10496"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter1_dd_1627_10496"
          width="109.347"
          height="109.347"
          x="8.535"
          y="15.585"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.5"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10496"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1627_10496"
            result="effect2_dropShadow_1627_10496"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10496"
            result="shape"
          ></feBlend>
        </filter>
        <filter
          id="filter2_dd_1627_10496"
          width="83.763"
          height="83.762"
          x="219.228"
          y="6.555"
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity="0" result="BackgroundImageFix"></feFlood>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset dy="0.5"></feOffset>
          <feGaussianBlur stdDeviation="1"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.376471 0 0 0 0 0.380392 0 0 0 0 0.439216 0 0 0 0.16 0"></feColorMatrix>
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_1627_10496"
          ></feBlend>
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          ></feColorMatrix>
          <feOffset></feOffset>
          <feGaussianBlur stdDeviation="0.5"></feGaussianBlur>
          <feColorMatrix values="0 0 0 0 0.156863 0 0 0 0 0.160784 0 0 0 0 0.239216 0 0 0 0.08 0"></feColorMatrix>
          <feBlend
            in2="effect1_dropShadow_1627_10496"
            result="effect2_dropShadow_1627_10496"
          ></feBlend>
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_1627_10496"
            result="shape"
          ></feBlend>
        </filter>
        <clipPath id="clip0_1627_10496">
          <path
            fill="#fff"
            d="M0 0H304V304H0z"
            transform="translate(0 .53)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
};

export default IllustrationHealth;
